import {IServerDistance} from '../serverModel/Distance';
import {IDistance} from 'Filters/models/Distance';

export function convertClientDistanceToServer(clientRequest?: IDistance): IServerDistance {
  return {unit: clientRequest?.unit, value: clientRequest?.value};
}
